export default "__VITE_ASSET__9dee6a59__"